import axios from "axios";
import router from "@/utils/router";
import {Toast,Dialog} from 'vant';
import 'vant/lib/index.css';
import aliOss from "ali-oss";

let baseUrl = '';
if (process.env.NODE_ENV == 'development') {
	baseUrl = '/api';
} else if (process.env.NODE_ENV == 'production') {
	baseUrl = 'https://gs.shuidashi.com';
}

axios.defaults.baseURL = baseUrl;
axios.defaults.timeout = 10000;

axios.interceptors.request.use(config => {
	config.headers.sid = localStorage.getItem('sid') || "";
	return config;
},error => {
	return Promise.reject(error);
});

axios.interceptors.response.use(response => {
	const data = response.data;
	if(data.errorCode == 101) {
		router.push('/login');
	}
	return response;
},error=>{
	const res = error.response;
	Dialog({
		title : res.status,
		message : res.statusText
	});
	return Promise.reject(res);
});

export function post(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, params).then(res => {
			resolve(res.data);
		}).catch(error=>{
			reject(error);
		});
	});
}
export function get(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url,{params: params}).then(res=>{
			resolve(res.data);
		}).catch(error => {
			reject(error);
		});
	});
}

export function upload(params = { }) {
	return new Promise((resolve, reject) => {
		
		if( !params.file ){
			reject('无上传的文件');
			Dialog({
				title : '提示',
				message : '缺少文件'
			});
			return false;
		}
		
		if( !params.dir ){
			reject('缺少文件目录名称');
			Dialog({
				title : '提示',
				message : '缺少文件目录名称'
			});
			return false;
		}
		
		axios.get('https://aoem.qidashi.com/getToken').then(config=>{
			let configData = config.data;
			if( configData.code == 100 ){
				
				let ossConfig = configData.data;
				let client = new aliOss({
					region : ossConfig.region,
					secure : true,
					accessKeyId : ossConfig.accesskeyId,
					accessKeySecret : ossConfig.accesskeySecret,
					stsToken : ossConfig.stsToken,
					bucket : ossConfig.bucket
				});
				
				const productName = "xgj";
				const file = params.file;
				const extIndex = file.name.lastIndexOf('.');
				const ext = file.name.substr(extIndex);
				const fileName = ossConfig.fileRandom + ext;
				
				client.put('shuidashi/yqb/' + productName + '/' + params.dir + '/' + fileName, file).then(data=>{
					
					if( data.res.status != 200 ){
						reject(data);
						Dialog({
							title : '上传失败',
							message : 'status:' + data.res.status
						});
						return false;
					}
					
					if( data.res.statusCode != 200 ){
						reject(data);
						Dialog({
							title : '上传失败',
							message : 'statusCode:' + data.res.statusCode
						});
						return false;
					}
					
					var reg = /^http(s)?:\/\/(.*?)\//
					resolve(data.url.replace(reg,"https://osspush.qidashi.com/"));
					
				}).catch(error=>{
					reject(error);
					Dialog({
						title : '上传失败',
						message : error
					});
				})
				
			}else{
				reject(config);
				Dialog({
					title : '提示',
					message : '上传配置出错'
				});
			}
			
		}).catch(error => {
			reject(error);
			Dialog({
				title : '提示',
				message : error
			});
		});
	});
}

export const apiHost = baseUrl;
